import { render, staticRenderFns } from "./config.vue?vue&type=template&id=2113136b&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=2113136b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113136b",
  null
  
)

export default component.exports